<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :backButtonRoute="backButtonRoute"
    ref="goods-return"
    :data-model="dataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :paging="false"
    class="goods-return"
  />
</template>
<script>
import TransactionTemplate from "@/templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { GoodsReturnService } from "@/_services/api/purchasing/goods-return.service";
import { formatNumber } from "devextreme/localization";
import { alert } from "devextreme/ui/dialog";
import CheckBox from "devextreme/ui/check_box";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      dataModel: {
        Name: "",
        DateIn: null,
        DateReceived: "",
        BranchCode: "",
        SupplierName: "",
        SupplierCode: "",
        PurchaseOrderCode: "",
        ResupplyPO: false,
        Comment: "",
        InvoicedLineCount: 0,
        SupplierCurrencyCode: "FX",
      },
      reload: false,
      validationSummary: [],
      ui: {
        DateInMin: null,
        DateInMax: null,
      },
      serverError: {},
      brokenGridValidations: [],
      headerToolBarForm: undefined,
      initialLoaded: false,
      expandChildGrid: false,
      gridDataLoaded: false,
      CollapseBtnContentReady: false,
      IsBatchAvailable: false,
    };
  },

  async created() {
    let response = await GoodsReturnService.getGoodsInByCode(this.baseView.id);

    this.dataModel.DateIn = new Date(); // response.data.value[0].DateIn;
    this.dataModel.DateReceived = response.data.value[0].DateReceived;
    this.dataModel.SupplierName = response.data.value[0].Supplier.Name;
    this.dataModel.SupplierCode = response.data.value[0].SupplierCode;
    this.dataModel.InvoicedLineCount = response.data.value[0].InvoicedLineCount;
    this.dataModel.DateChanged = response.data.value[0].DateChanged;

    if (
      response.data.value[0].Supplier &&
      response.data.value[0].Supplier.CurrencyCode
    )
      this.dataModel.SupplierCurrencyCode =
        response.data.value[0].Supplier.CurrencyCode;

    await this.setActiveAccountingPeriod();
    this.initialized();
  },
  computed: {
    backButtonRoute() {
      let goBackRoute = "/goods-return";
      if (this.baseView.query)
        if (this.baseView.query.redirect)
          goBackRoute = this.baseView.query.redirect;

      return goBackRoute;
    },
    getScreenJson() {
      return {
        title: "Goods Return",
        endpoint: {
          // primary: "CashReceipt",
          // expand: "Customer($select=Name)",
          // CodeBy: this.baseView.mode !== "review" ? "text" : undefined,
          // postProcess: this.cashReceiptPostProcess,
        },
        headerData: {
          headerFormVisible: false,
          headerToolbar: {
            audit: false,
            status: false,
            notes: false,
            save: false,
            saveCallback: this.saveGoodsReturn,

            commentsTitle: "Goods Return Comments",

            commentItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "Comment",
                    editorType: "dxTextArea",
                    editorOptions: {
                      // format: this.getDecimalFormatByCode(6).Format,
                      height: "140",
                      maxLength: 1000,
                    },
                    validationRules: [],
                    label: {
                      text: " ",
                      location: "top",
                    },
                  },
                ],
              },
            ],
          },
          // formItems: [
          // ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text: "Create Goods Return for Goods In # " + this.baseView.id,
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: "SupplierName",
              text: undefined,
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "GoodsInDetail",
              filter: [["GoodsInCode eq " + this.baseView.id]],
              serverPaging: true,
              allowGrouping: false,
              // expand: "SaleItem",
              postProcessCallback: this.PostProcess,
            },
            options: {
              dxPaging: false,
              onContentReadyCallBack: this.onContentReadyCallBack,
            },
            // noDataMessage: {
            //   // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
            //   review: {
            //     addNew: {
            //       class: "no-data",
            //       title: "No Credit Lines",
            //       message: "Get Started, Add a Credit Line",
            //     },
            //   },
            // },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            review: false,
            note: true,
            save: this.baseView.mode !== "review",
            // saveCallback: this.saveGoodsIn,

            customButtons: [
              {
                icon: this.expandChildGrid ? "chevronup" : "chevrondown",
                label: this.getLabel,
                clickAction: () => {
                  this.expandMasterDetailsSection();
                },
                buttonLocation: "left",
                elementAttr: {
                  class: "colps-expnd-btn",
                },
                onContentReady: this.onCollapseBtnContentReady,
                visible: this.IsBatchAvailable,
              },
            ],
            form: {
              location: "left",
              formContentReady: this.formContentReady,
              items: [
                {
                  dataField: "DateIn",
                  label: {
                    text: "Date",
                  },
                  editorType: "dxDateBox",
                  cssClass: "date-in-container",
                  editorOptions: {
                    displayFormat: "dd MMM yyyy",
                    width: 120,
                    min: this.ui.DateInMin,
                    max: this.ui.DateInMax,
                    readOnly: this.baseView.mode === "review",
                    onKeyDown: this.onDateInKeyDown,
                  },
                  validationRules: [
                    {
                      type: "required",
                      message: "Date is required",
                    },
                  ],
                },

                {
                  dataField: "DateReceived",
                  label: "Date Received",
                  editorType: "dxDateBox",
                  cssClass: "date-in-container",
                  editorOptions: {
                    displayFormat: "dd MMM yyyy",
                    width: 120,
                    disabled: true,
                  },
                },
              ],
            },

            formSwitch: {
              location: "right",
              items: [
                {
                  dataField: "ResupplyPO",
                  label: { text: "Re-Supply Purchase Order" },
                  editorType: "dxSwitch",
                  editorOptions: {
                    readOnly: this.baseView.mode === "review",
                  },
                },
              ],
            },
          },

          childColumns: this.getChildColumn,
          columns: [
            {
              screenField: "CheckInclude",
              dataField: "CheckInclude",
              allowEditing: false,
              defaultValue: false,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: false,
              fixed: true,
              fixedPosition: "left",
              label: "",
              width: 50,
              minWidth: 50,
              makeDisabled: (cellInfo) => {
                return !!cellInfo.data.IncludeDisabled;
              },
            },
            {
              screenField: "ProductItem",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              sortOrder: "asc",
              sortIndex: 0,
              label: "Product / Account",
              gridDataField: "ItemCode",
            },
            {
              screenField: "PurchaseOrder",
              dataField: "PurchaseOrderCode",
              width: ColumnWidth.PurchaseOrderWrap.width,
              minWidth: ColumnWidth.PurchaseOrderWrap.minWidth,
              visible: true,
              allowSearch: false,
              hyperlink: {
                url: `purchase-order/review/__ID__`,
                dataField: "PurchaseOrderCode",
                target: "_blank",
              },
            },
            {
              screenField: "Invoice",
              label: "GCORP Invoice",
              dataField: "SupplierInvoiceRef",
              width: ColumnWidth.InvoiceRef.width + 10,
              minWidth: ColumnWidth.InvoiceRef.minWidth + 10,
              hyperlink: {
                url: `supplier-invoice/review/__ID__`,
                dataField: "SupplierInvoiceRef",
                target: "_blank",
              },
              allowSearch: true,
              visible: this.dataModel.InvoicedLineCount > 0,
            },

            {
              screenField: "Branch",
              cellTemplate: undefined,
              gridDataField: "BranchCode",
              width: ColumnWidth.BranchCode.width,
              minWidth: ColumnWidth.BranchCode.minWidth,
            },
            {
              screenField: "Division",
              cellTemplate: undefined,
              gridDataField: "DivisionCode",
              width: ColumnWidth.Division.width,
              minWidth: ColumnWidth.Division.minWidth,
            },
            {
              screenField: "SalesUM",
              dataField: "SupplierUM",
              width: ColumnWidth.UnitOfMeasure.width,
              minWidth: ColumnWidth.UnitOfMeasure.minWidth,
            },
            {
              // screenField: "Tax",
              gridLabel: "Tax",
              dataField: "TaxCode",
              width: ColumnWidth.TaxCode.width,
              minWidth: ColumnWidth.TaxCode.minWidth,
            },
            {
              screenField: "Quantity",
              dataField: "SupplierReceivedQty",
              label: "Received",
              cellTemplate: "Decimal",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
              format: "Decimal-16-4",
            },
            {
              screenField: "Quantity",
              dataField: "SupplierAllReturnedQty",
              label: "Returned",
              cellTemplate: "Decimal",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
              format: "Decimal-16-4",
            },
            {
              screenField: "Quantity",
              dataField: "SupplierOutstandingReturnQty",
              label: "Available",
              cellTemplate: "Decimal",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
              format: "Decimal-16-4",
            },

            {
              screenField: "Quantity",
              dataField: "SupplierReturnedQty",
              label: "To Return",
              type: "EditableDecimal",
              format: "Decimal-16-4",
              showEditorAlways: true,
              makeDisabled: (data) => {
                return !!(
                  data.data.IncludeDisabled || data.data.IsBatchProduct !== "No"
                );
              },
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
              onKeyDown: this.onSupplierReturnedQtyKeyDown,
            },
            {
              screenField: "SalesUMFXPrice",
              label: `Unit Price (${this.dataModel.SupplierCurrencyCode})`,
              gridDataField: "SupplierFXPrice",
              format: "Decimal-16-4C",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "FXLineTotal",
              gridLabel: `Ex Total (${this.dataModel.SupplierCurrencyCode})`,
              gridDataField: "ExFXTotal",
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "TaxFXTotal",
              gridLabel: `Tax (${this.dataModel.SupplierCurrencyCode})`,
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "IncTaxFXTotal",
              gridLabel: `Inc Total (${this.dataModel.SupplierCurrencyCode})`,
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
          ],

          valueChangedEventListners: [
            {
              dataField: "SupplierReturnedQty",
              listner: (e, lineData) => {
                this.onSupplierReturnedQtyUpdate(e, lineData);
              },
            },
            {
              dataField: "SupplierBatchReturnedQty",
              listner: (e, lineData, items, grid, lineParent) => {
                this.onSupplierBatchReturnedQtyUpdate(
                  e,
                  lineData,
                  items,
                  grid,
                  lineParent
                );
              },
            },
          ],

          ellipsisColumn: {
            items: [
              {
                label: "Line Comment",
                clickAction: "lineComment",
              },
            ],
            keyExpr: "label",
            displayExpr: "label",
            formItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "GoodsInComment",
                    label: { text: "Comment", visible: false },
                    editorType: "dxTextArea",
                    editorOptions: {
                      maxLength: 100,
                      height: 70,
                    },
                  },
                ],
              },
            ],
          },
        },
        footerData: {
          footerItems: [
            {
              screenField: "Quantity",
              dataField: "SupplierReturnedQty",
              location: "left",
              label: "Item Count",
              value: 0,
              format: "Decimal-16-0",
            },
            {
              screenField: "SalesUMItemCount",
              dataField: "SupplierRequired",
              location: "left",
              label: "Line Count",
              value: 0,
              customCalc: (headerData, gridItems) => {
                let count = 0;
                gridItems.forEach((element) => {
                  if (element.CheckInclude) count++;
                });

                return count;
              },
            },
            {
              dataField: "ExFXTotal",
              screenField: "TaxableFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Sub Total(${this.dataModel.SupplierCurrencyCode})`,
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Tax (${this.dataModel.SupplierCurrencyCode})`,
            },
            {
              screenField: "FXTotal",
              dataField: "IncTaxFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Total (${this.dataModel.SupplierCurrencyCode})`,
            },
          ],
        },
      };
    },
    getLabel() {
      return this.expandChildGrid ? "Collapse" : "Expand";
    },
  },
  methods: {
    onCollapseBtnContentReady(e) {
      this.CollapseBtnContentReady = e;
    },
    expandMasterDetailsSection() {
      let gridInstance =
        this.$refs["goods-return"].$refs.transactionGrid.getGridInstance();
      let items = gridInstance.getDataSource().items();
      if (this.expandChildGrid) {
        this.expandChildGrid = false;
        items.forEach((element, index) => {
          if (element.ChildDataSource && element.ChildDataSource.length > 0) {
            setTimeout(() => {
              gridInstance.collapseRow(element);
            }, 100 * index);
          }
        });
      } else {
        this.expandChildGrid = true;
        items.forEach((element, index) => {
          if (element.ChildDataSource && element.ChildDataSource.length > 0) {
            setTimeout(() => {
              gridInstance.expandRow(element);
            }, 150 * index);
          }
        });
      }
      setTimeout(() => {
        gridInstance.refresh(true).then(() => {
          if (this.CollapseBtnContentReady) {
            this.CollapseBtnContentReady.component.beginUpdate();
            this.CollapseBtnContentReady.component.option(
              "text",
              this.getLabel
            );
            this.CollapseBtnContentReady.component.option(
              "icon",
              this.expandChildGrid ? "chevronup" : "chevrondown"
            );
            this.CollapseBtnContentReady.component.endUpdate();
          }
        });
      }, 500);
    },
    getChildColumn(data) {
      return [
        {
          screenField: "CheckInclude",
          gridDataField: "CheckInclude",
          allowEditing: false,
          // defaultValue: false,
          valueChangeCallBack: this.checkBoxBatchValueChange,
          allowHiding: false,
          showInColumnChooser: false,
          // fixed: true,
          // fixedPosition: "left",
          label: "",
          width: 50,
          minWidth: 50,
          makeDisabled: (cellInfo) => {
            return cellInfo.data.IncludeDisabled;
          },
        },
        {
          screenField: "Batch",
          gridDataField: "BatchNo",
          width: 461,
          minWidth: ColumnWidth.BatchNo.minWidth,
        },
        {
          screenField: "SupplierBatchNo",
          width: 470,
          minWidth: ColumnWidth.SupplierBatchNo.minWidth,
        },
        {
          screenField: "Quantity",
          dataField: "SupplierReceivedQty",
          label: "Received",
          format: "Decimal-16-4",
          width: ColumnWidth.Quantity4DecimalPoints.width,
        },
        {
          screenField: "Quantity",
          dataField: "TotalSupplierReturnedQty",
          label: "Returned",
          // cellTemplate: "Decimal",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "Decimal-16-4",
        },
        {
          screenField: "Quantity",
          dataField: "AvailableQty",
          label: "Available",
          format: "Decimal-16-4",
          width: ColumnWidth.Quantity4DecimalPoints.width,
        },
        {
          screenField: "Quantity",
          dataField: "SupplierBatchReturnedQty",
          type: "EditableDecimal",
          label: "To Return",
          format: "Decimal-16-4",
          showEditorAlways: true,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          makeDisabled: (data) => {
            return data.data.IncludeDisabled;
          },
          editorOptions: {
            onKeyDown: this.onSupplierBatchReturnedQtyKeyDown,
          },
        },
        {
          screenField: "ManufacturedDate",
          gridDataField: "ManufacturedDate",
          label: "Manufactured Date",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
        },
        {
          screenField: "UseByDate",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
          visible: data.data.ChildDataSource[0].UseByDate !== null,
        },
        {
          screenField: "BestBeforeDate",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
          visible: data.data.ChildDataSource[0].BestBeforeDate !== null,
        },
      ];
    },
    onDateInKeyDown(e) {
      if (e.event) {
        if (e.event.key === "Tab" && e.event.shiftKey === false) {
          e.event.preventDefault();
          let gridInstance =
            this.$refs["goods-return"].$refs.transactionGrid.getGridInstance();
          let items = gridInstance.getDataSource().items();
          if (items.length > 0) {
            let index = items.findIndex((x) => !x.IncludeDisabled);
            if (index !== -1) {
              let data = items[index];
              if (data.IsBatchProduct === "No") {
                let getIndex = gridInstance.getRowIndexByKey(data);
                this.focusOnEditingCell(getIndex, "SupplierReturnedQty");
              } else {
                gridInstance.expandRow(items[index]).then(() => {
                  setTimeout(() => {
                    let childGridInstance = this.$refs[
                      "goods-return"
                    ].$refs.transactionGrid.getMasterDataInstance(data.LineNo);

                    let batchItems = childGridInstance.getDataSource().items();

                    if (batchItems.length > 0 && childGridInstance) {
                      let cellElement = childGridInstance.getCellElement(
                        0,
                        "SupplierBatchReturnedQty"
                      );
                      if (cellElement) {
                        childGridInstance.focus(cellElement);
                      }
                    }
                  }, 1);
                });
              }
            }
          }
        }
      }
    },
    onSupplierReturnedQtyKeyDown(e, lineInfo) {
      if (e.event) {
        let gridInstance =
          this.$refs["goods-return"].$refs.transactionGrid.getGridInstance();
        let items = gridInstance.getDataSource().items();
        let lineIndex = items.findIndex(
          (x) => x.LineNo === lineInfo.data.LineNo
        );
        if (e.event.key === "Tab" && e.event.shiftKey === false) {
          if (items.length > 0) {
            if (lineIndex !== -1 && lineIndex + 1 <= items.length) {
              let i = [...items];
              let index =
                i.splice(lineIndex + 1).findIndex((x) => !x.IncludeDisabled) +
                1 +
                lineIndex;

              if (index > lineIndex) {
                let data = items[index];
                if (data.IsBatchProduct !== "No") {
                  e.event.preventDefault();
                  gridInstance.expandRow(items[index]).then(() => {
                    setTimeout(() => {
                      let childGridInstance = this.$refs[
                        "goods-return"
                      ].$refs.transactionGrid.getMasterDataInstance(
                        data.LineNo
                      );

                      let batchItems = childGridInstance
                        .getDataSource()
                        .items();

                      if (batchItems.length > 0 && childGridInstance) {
                        let cellElement = childGridInstance.getCellElement(
                          0,
                          "SupplierBatchReturnedQty"
                        );
                        if (cellElement) {
                          childGridInstance.focus(cellElement);
                        }
                      }
                    }, 1);
                  });
                }
              }
            }
          }
        } else if (e.event.key === "Tab" && e.event.shiftKey === true) {
          e.event.preventDefault();
          if (lineIndex !== -1) {
            if (lineIndex === 0) {
              setTimeout(() => {
                if (
                  this.headerToolBarForm &&
                  this.headerToolBarForm.getEditor("DateIn")
                ) {
                  this.headerToolBarForm.getEditor("DateIn").instance().focus();
                }
              }, 1);
            } else {
              this.moveToPrevLineMainOrBatch(lineIndex);
            }
          }
        }
      }
    },
    onSupplierBatchReturnedQtyKeyDown(e, lineInfo, parentLine) {
      if (e.event) {
        let instance = lineInfo.component;
        let gridInstance = parentLine.component;
        if (e.event.key === "Tab" && e.event.shiftKey === false) {
          e.event.preventDefault();
          let items = instance.getDataSource().items();
          if (items[lineInfo.rowIndex + 1]) {
            setTimeout(() => {
              if (instance) {
                let cellElement = instance.getCellElement(
                  lineInfo.rowIndex + 1,
                  "SupplierBatchReturnedQty"
                );
                if (cellElement) {
                  instance.focus(cellElement);
                }
              }
            }, 100);
          } else {
            let items = gridInstance.getDataSource().items();

            let index = items.findIndex(
              (x) => x.LineNo === parentLine.data.LineNo
            );
            if (index !== -1 && items[index + 1]) {
              let data = items[index + 1];
              if (data.IsBatchProduct === "No") {
                let rowIndex = gridInstance.getRowIndexByKey(items[index + 1]);
                if (rowIndex !== -1)
                  this.focusOnEditingCell(rowIndex, "SupplierReturnedQty");
              } else {
                let i = [...items];
                let index2 =
                  i.splice(index + 1).findIndex((x) => !x.IncludeDisabled) +
                  1 +
                  index;

                if (index2 <= items.length) {
                  let data = items[index2];
                  if (data.IsBatchProduct === "No") {
                    let rowIndex = gridInstance.getRowIndexByKey(data);
                    if (rowIndex !== -1)
                      this.focusOnEditingCell(rowIndex, "SupplierReturnedQty");
                  } else {
                    gridInstance.expandRow(data).then(() => {
                      setTimeout(() => {
                        let childGridInstance = this.$refs[
                          "goods-return"
                        ].$refs.transactionGrid.getMasterDataInstance(
                          data.LineNo
                        );

                        let batchItems = childGridInstance
                          .getDataSource()
                          .items();

                        if (batchItems.length > 0 && childGridInstance) {
                          let cellElement = childGridInstance.getCellElement(
                            0,
                            "SupplierBatchReturnedQty"
                          );
                          if (cellElement) {
                            childGridInstance.focus(cellElement);
                          }
                        }
                      }, 1);
                    });
                  }
                }
              }
            }
          }
        } else if (e.event.key === "Tab" && e.event.shiftKey === true) {
          e.event.preventDefault();
          let getIndex = instance.getRowIndexByKey(lineInfo.data);
          if (getIndex !== -1) {
            if (getIndex > 0) {
              let cellElement = instance.getCellElement(
                getIndex - 1,
                "SupplierBatchReturnedQty"
              );
              if (cellElement) {
                instance.focus(cellElement);
              }
            } else {
              let parentItems = gridInstance.getDataSource().items();
              let parentIndex = parentItems.findIndex(
                (x) => x.LineNo === parentLine.data.LineNo
              );
              if (parentIndex !== -1)
                this.moveToPrevLineMainOrBatch(parentIndex);
            }
          }
        }
      }
    },
    moveToPrevLineMainOrBatch(lineIndex) {
      let gridInstance =
        this.$refs["goods-return"].$refs.transactionGrid.getGridInstance();
      let items = gridInstance.getDataSource().items();
      let prevItems = [...items].splice(0, lineIndex);
      let prevIndex = -1;
      for (let i = prevItems.length - 1; i >= 0; i--) {
        if (!prevItems[i].IncludeDisabled) {
          prevIndex = i;
          break;
        }
      }

      if (prevIndex !== -1) {
        let data = items[prevIndex];
        if (data.IsBatchProduct === "No") {
          let getIndex = gridInstance.getRowIndexByKey(data);
          this.focusOnEditingCell(getIndex, "SupplierReturnedQty");
        } else {
          gridInstance.expandRow(data).then(() => {
            setTimeout(() => {
              let childGridInstance = this.$refs[
                "goods-return"
              ].$refs.transactionGrid.getMasterDataInstance(data.LineNo);

              let batchItems = childGridInstance.getDataSource().items();

              if (batchItems.length > 0 && childGridInstance) {
                let cellElement = childGridInstance.getCellElement(
                  batchItems.length - 1,
                  "SupplierBatchReturnedQty"
                );
                if (cellElement) {
                  childGridInstance.focus(cellElement);
                }
              }
            }, 1);
          });
        }
      } else {
        setTimeout(() => {
          if (
            this.headerToolBarForm &&
            this.headerToolBarForm.getEditor("DateIn")
          ) {
            this.headerToolBarForm.getEditor("DateIn").instance().focus();
          }
        }, 1);
      }
    },
    formContentReady(e) {
      this.headerToolBarForm = e.component;
    },
    onContentReadyCallBack() {
      setTimeout(() => {
        if (
          this.headerToolBarForm &&
          this.headerToolBarForm.getEditor("DateIn") &&
          !this.initialLoaded
        ) {
          this.initialLoaded = true;
          this.headerToolBarForm.getEditor("DateIn").instance().focus();
        }
      }, 500);

      if (this.gridDataLoaded === false) {
        this.gridDataLoaded = true;
        setTimeout(() => {
          this.expandMasterDetailsSection();
        }, 500);
      }
    },
    async onSupplierReturnedQtyUpdate(e, lineData) {
      if (e.value < 0 && lineData.data.LineType !== "G") {
        let alert = await this.$alert(
          `${lineData.data.ItemDescription}  has a Received quantity that is greater than 0.00. To Return quantity should be greater than 0.00.`,
          "Validation Errors"
        );
        if (alert) {
          e.value = lineData.data.SupplierReturnedQty;
          this.focusOnEditingCell(lineData.rowIndex, lineData.column.dataField);
        }
      } else {
        lineData.data.CheckInclude = 0 > e.value;
      }

      if (
        e.event &&
        lineData.data.AvailableQty >= lineData.data.SupplierOutstandingReturnQty
      ) {
        let isValid = true;
        if (e.value > 0) {
          if (e.value > lineData.data.SupplierOutstandingReturnQty) {
            isValid = false;
          }
        } else if (lineData.data.SupplierOutstandingReturnQty < 0) {
          isValid =
            e.value >= lineData.data.SupplierOutstandingReturnQty &&
            lineData.data.LineType === "G";
        }

        if (!isValid) {
          let alert = null;
          if (lineData.data.LineType === "G") {
            if (e.value > lineData.data.SupplierOutstandingReturnQty) {
              alert = await this.$alert(
                `${lineData.data.ItemCode} - ${lineData.data.ItemDescription} has a Received quantity that is less than 0.00. To Return quantity should be less than 0.00.`,
                "Validation Errors"
              );
            } else {
              alert = await this.$alert(
                `${lineData.data.ItemCode} - ${lineData.data.ItemDescription} has a Return quantity of ${e.value}, which is more than the Outstanding Return quantity of ${lineData.data.SupplierOutstandingReturnQty}. Update the To Return quantity so that it is more than or equal to ${lineData.data.SupplierOutstandingReturnQty}`,
                "Validation Errors"
              );
            }
          } else {
            alert = await this.$alert(
              `${lineData.data.ItemCode} - ${
                lineData.data.ItemDescription
              } has a Return quantity of ${formatNumber(
                e.value,
                "##,###,###,###,##0.00"
              )}, which is more than the Outstanding Return quantity of ${formatNumber(
                lineData.data.SupplierOutstandingReturnQty,
                "##,###,###,###,##0.00"
              )}. Update the To Return quantity so that it is less than or equal to ${formatNumber(
                lineData.data.SupplierOutstandingReturnQty,
                "##,###,###,###,##0.00"
              )}.`,
              "Validation Errors"
            );
          }

          if (alert) {
            e.value = lineData.data.SupplierReturnedQty;
            this.focusOnEditingCell(
              lineData.rowIndex,
              lineData.column.dataField
            );
          }
        }
      } else {
        if (e.event && e.value > lineData.data.AvailableQty) {
          let alert = await this.$alert(
            `${lineData.data.ItemCode} - ${
              lineData.data.ItemDescription
            } has a Return quantity of ${formatNumber(
              e.value,
              "##,###,###,###,##0.00"
            )} which is more than the Available quantity of ${formatNumber(
              lineData.data.AvailableQty,
              "##,###,###,###,##0.00"
            )}. Update the To Return quantity so that it is less than or equal to ${formatNumber(
              lineData.data.AvailableQty,
              "##,###,###,###,##0.00"
            )}.`,
            "Validation Errors"
          );
          if (alert) {
            e.value = lineData.data.SupplierReturnedQty;
            this.focusOnEditingCell(
              lineData.rowIndex,
              lineData.column.dataField
            );
          }
        }
      }

      const gridItems = lineData.component.getDataSource().items();
      this.onSupplierReturnedQtyChange(e, lineData, gridItems);
    },

    focusOnEditingCell(rowIndex, dataField) {
      setTimeout(() => {
        let gridInstance =
          this.$refs["goods-return"].$refs.transactionGrid.getGridInstance();
        if (gridInstance) {
          let cellElement = gridInstance.getCellElement(rowIndex, dataField);
          if (cellElement) {
            gridInstance.focus(cellElement);
          }
        }
      }, 500);
    },
    checkBoxBatchValueChange(
      fieldData,
      recordData,
      checkBoxInstance,
      gridInstance
    ) {
      if (!fieldData.event) return;

      if (recordData.rowType === "header") {
        const gridItems = recordData.component.getDataSource().items();
        if (fieldData.value) {
          let total = 0;
          let LineNo = undefined;
          gridItems.forEach((batch) => {
            LineNo = batch.GoodsInLineNo;
            let batchToReturn;
            if (batch.AvailableQty >= batch.OutstandingSupplierReturnQty)
              batchToReturn = batch.OutstandingSupplierReturnQty;
            else batchToReturn = batch.AvailableQty;

            total = total + batchToReturn;
            batch.SupplierBatchReturnedQty = batchToReturn;
            batch.CheckInclude = true;
          });

          let parentItems = gridInstance.getDataSource().items();
          let index = parentItems.findIndex((x) => x.LineNo === LineNo);
          if (index !== -1) {
            let lineItem = parentItems[index];
            lineItem.CheckInclude = true;
            lineItem.SupplierReturnedQty = total;
            lineItem.ExFXTotal = (total * lineItem.SupplierFXPrice).roundNumber(
              2
            );
            if (lineItem.TaxRate === 0) {
              lineItem.TaxFXTotal = 0;
              lineItem.IncTaxFXTotal = (
                total * lineItem.SupplierFXPrice
              ).roundNumber(2);
            } else {
              lineItem.TaxFXTotal = (
                total *
                lineItem.SupplierFXPrice *
                (1 / lineItem.TaxRate)
              ).roundNumber(2);
              lineItem.IncTaxFXTotal = (
                total * lineItem.SupplierFXPrice +
                total * lineItem.SupplierFXPrice * (1 / lineItem.TaxRate)
              ).roundNumber(2);
            }
          }
        } else {
          let LineNo = undefined;
          gridItems.map((batch) => {
            LineNo = batch.GoodsInLineNo;
            batch.SupplierBatchReturnedQty = 0;
            batch.CheckInclude = false;
          });

          let parentItems = gridInstance.getDataSource().items();
          let index = parentItems.findIndex((x) => x.LineNo === LineNo);
          if (index !== -1) {
            let lineItem = parentItems[index];
            lineItem.CheckInclude = false;
            lineItem.SupplierReturnedQty = 0;
            lineItem.ExFXTotal = 0;
            lineItem.TaxFXTotal = 0;
            lineItem.IncTaxFXTotal = 0;
          }
        }
        this.$nextTick(() => {
          recordData.component.refresh();
        });
      } else {
        let lineData = recordData.data;
        // if (fieldData.value) {
        let batchToReturn;
        if (lineData.AvailableQty >= lineData.OutstandingSupplierReturnQty)
          batchToReturn = lineData.OutstandingSupplierReturnQty;
        else batchToReturn = lineData.AvailableQty;

        lineData.SupplierBatchReturnedQty = fieldData.value ? batchToReturn : 0;
        lineData.CheckInclude = !!fieldData.value;

        this.$nextTick(() => {
          recordData.component.refresh().then(() => {
            const gridItems = recordData.component.getDataSource().items();
            let total = 0;
            let LineNo = undefined;
            let includeCount = 0;
            gridItems.forEach((element) => {
              LineNo = element.GoodsInLineNo;
              if (element.CheckInclude) {
                includeCount += 1;
                total += element.SupplierBatchReturnedQty;
              }
            });

            let parentItems = gridInstance.getDataSource().items();
            let index = parentItems.findIndex((x) => x.LineNo === LineNo);

            if (total > 0) {
              if (index !== -1) {
                let lineItem = parentItems[index];
                lineItem.CheckInclude = true;
                lineItem.SupplierReturnedQty = total;
                lineItem.ExFXTotal = (
                  total * lineItem.SupplierFXPrice
                ).roundNumber(2);
                if (lineItem.TaxRate === 0) {
                  lineItem.TaxFXTotal = 0;
                  lineItem.IncTaxFXTotal = (
                    total * lineItem.SupplierFXPrice
                  ).roundNumber(2);
                } else {
                  lineItem.TaxFXTotal = (
                    total *
                    lineItem.SupplierFXPrice *
                    (1 / lineItem.TaxRate)
                  ).roundNumber(2);
                  lineItem.IncTaxFXTotal = (
                    total * lineItem.SupplierFXPrice +
                    total * lineItem.SupplierFXPrice * (1 / lineItem.TaxRate)
                  ).roundNumber(2);
                }
              }
            } else {
              if (index !== -1) {
                let lineItem = parentItems[index];
                lineItem.CheckInclude = false;
                lineItem.SupplierReturnedQty = 0;
                lineItem.ExFXTotal = 0;
                lineItem.TaxFXTotal = 0;
                lineItem.IncTaxFXTotal = 0;
              }
            }

            if (includeCount === 0) checkBoxInstance.option("value", false);
            else if (includeCount !== gridItems.length)
              checkBoxInstance.option("value", undefined);
            else checkBoxInstance.option("value", true);
          });
        });
        // }
      }
    },

    setBatchToReturn(batch, total) {
      batch.forEach((batch) => {
        let batchToReturn;
        if (batch.AvailableQty >= batch.OutstandingSupplierReturnQty)
          batchToReturn = batch.OutstandingSupplierReturnQty;
        else batchToReturn = batch.AvailableQty;

        total = total + batchToReturn;
        batch.SupplierBatchReturnedQty = batchToReturn;
        batch.CheckInclude = true;
      });
      return total;
    },
    checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) return;

      const gridItems = recordData.component.getDataSource().items();

      if (recordData.rowType === "header") {
        if (typeof fieldData.value !== "undefined") {
          let chekdItems = gridItems.filter((x) => x.CheckInclude);
          let noInvItems = gridItems.filter((x) => !x.IncludeDisabled);
          gridItems.forEach((element) => {
            if (element.IncludeDisabled) return;
            if (chekdItems.length === noInvItems.length)
              fieldData.value = false;

            if (fieldData.value) {
              if (!element.CheckInclude) {
                element.CheckInclude = true;
                if (
                  element.ChildDataSource &&
                  element.ChildDataSource.length > 0
                ) {
                  let total = 0;
                  element.ChildDataSource.forEach((batch) => {
                    let batchToReturn;
                    if (
                      batch.AvailableQty >= batch.OutstandingSupplierReturnQty
                    )
                      batchToReturn = batch.OutstandingSupplierReturnQty;
                    else batchToReturn = batch.AvailableQty;
                    total = total + batchToReturn;
                    batch.SupplierBatchReturnedQty = batchToReturn;
                    batch.CheckInclude = true;
                  });

                  this.onSupplierReturnedQtyChange(
                    { value: total },
                    { data: element, component: recordData.component },
                    gridItems,
                    true
                  );
                } else {
                  let toReturn;
                  if (
                    element.AvailableQty >= element.SupplierOutstandingReturnQty
                  )
                    toReturn = element.SupplierOutstandingReturnQty;
                  else toReturn = element.AvailableQty;
                  this.onSupplierReturnedQtyChange(
                    { value: toReturn },
                    { data: element },
                    gridItems
                  );
                }
              }
            } else {
              element.CheckInclude = false;
              let isBatch = false;

              if (
                element.ChildDataSource &&
                element.ChildDataSource.length > 0
              ) {
                isBatch = true;
                element.ChildDataSource.forEach((batch) => {
                  batch.SupplierBatchReturnedQty = 0;
                  batch.CheckInclude = false;
                });
              }
              this.onSupplierReturnedQtyChange(
                { value: fieldData.value ? element.SupplierAvailableQty : 0 },
                { data: element, component: recordData.component },
                gridItems,
                isBatch
              );
            }
          });
        }
      } else {
        if (fieldData.value) {
          recordData.data.CheckInclude = true;

          let toReturn = 0;
          if (
            recordData.data.AvailableQty >=
            recordData.data.SupplierOutstandingReturnQty
          )
            toReturn = recordData.data.SupplierOutstandingReturnQty;
          else toReturn = recordData.data.AvailableQty;

          if (
            recordData.data.ChildDataSource &&
            recordData.data.ChildDataSource.length > 0
          ) {
            let total = this.setBatchToReturn(
              recordData.data.ChildDataSource,
              0
            );

            this.onSupplierReturnedQtyChange(
              { value: total },
              recordData,
              gridItems,
              true
            );
          } else
            this.onSupplierReturnedQtyChange(
              { value: toReturn },
              recordData,
              gridItems
            );
        } else {
          if (
            recordData.data.ChildDataSource &&
            recordData.data.ChildDataSource.length > 0
          ) {
            recordData.data.ChildDataSource.forEach((batch) => {
              batch.SupplierBatchReturnedQty = 0;
              batch.CheckInclude = false;
            });
          }

          recordData.data.CheckInclude = false;
          this.onSupplierReturnedQtyChange(
            { value: 0 },
            recordData,
            gridItems,
            recordData.data.IsBatchProduct !== "No"
          );
        }
      }
    },

    async onSupplierBatchReturnedQtyUpdate(
      e,
      lineData,
      items,
      grid,
      lineParent
    ) {
      if (
        lineData.data.AvailableQty >= lineData.data.OutstandingReturnQty &&
        e.value > lineData.data.OutstandingReturnQty
      ) {
        var message = `Batch ${lineData.data.BatchNo} for ${
          lineParent.data.ItemCode
        } - ${
          lineParent.data.ItemDescription
        } has a Return quantity of ${formatNumber(
          e.value,
          "##,###,###,###,##0.00"
        )}, which is more than the Outstanding Return quantity of ${formatNumber(
          lineData.data.OutstandingReturnQty,
          "##,###,###,###,##0.00"
        )}. Update the To Return quantity so that it is less than or equal to  ${formatNumber(
          lineData.data.OutstandingReturnQty,
          "##,###,###,###,##0.00"
        )}.`;
        await alert(message, "Validation Errors");
        e.value = lineData.data.SupplierBatchReturnedQty;
        this.refocusOnBatchGrid(e, lineData.data, "SupplierBatchReturnedQty");
      } else if (e.value < 0) {
        await alert(
          `Item : ${lineParent.data.ItemDescription}  has a Received quantity that is greater than 0.00. To Return quantity should be greater than 0.00.`,
          "Validation Errors"
        );
        e.value = lineData.data.SupplierBatchReturnedQty;
        this.refocusOnBatchGrid(e, lineData.data, "SupplierBatchReturnedQty");
      } else if (
        lineData.data.AvailableQty < lineData.data.OutstandingReturnQty &&
        e.value > lineData.data.AvailableQty
      ) {
        message = `Batch ${lineData.data.BatchNo} for ${
          lineParent.data.ItemCode
        } - ${
          lineParent.data.ItemDescription
        } has a Return quantity of ${formatNumber(
          e.value,
          "##,###,###,###,##0.00"
        )}, which is more than the Available quantity of ${formatNumber(
          lineData.data.AvailableQty,
          "##,###,###,###,##0.00"
        )}. Update the To Return quantity so that it is less than or equal to ${formatNumber(
          lineData.data.AvailableQty,
          "##,###,###,###,##0.00"
        )}`;

        await alert(message, "Validation Errors");
        e.value = lineData.data.SupplierBatchReturnedQty;
        this.refocusOnBatchGrid(e, lineData.data, "SupplierBatchReturnedQty");
      }

      if (e.component) {
        e.component.beginUpdate();
        e.component.option("value", e.value);
        e.component.endUpdate();
      }
      this.onSupplierBatchReturnedQtyChange(
        e.value,
        lineData,
        items,
        grid,
        lineParent
      );
    },
    refocusOnBatchGrid(e, data, dataField) {
      let childGridInstance = this.$refs[
        "goods-return"
      ].$refs.transactionGrid.getMasterDataInstance(data.GoodsInLineNo);

      let batchRowIndex = childGridInstance.getRowIndexByKey(data);
      if (childGridInstance) {
        let cellElement = childGridInstance.getCellElement(
          batchRowIndex,
          dataField
        );
        if (cellElement) {
          childGridInstance.focus(cellElement);
          setTimeout(() => {
            e.element.querySelector(".dx-texteditor-input").select();
          }, 1);
        }
      }
    },
    updateLineTotals(value, recordData, gridInstance) {
      let lineData = recordData.data;

      lineData.CheckInclude = !!value;

      this.$nextTick(() => {
        recordData.component.refresh().then(() => {
          const gridItems = recordData.component.getDataSource().items();

          let total = 0;
          let LineNo = undefined;
          gridItems.forEach((element) => {
            LineNo = element.GoodsInLineNo;

            if (
              element.CheckInclude &&
              LineNo !== recordData.data.GoodsInLineNo
            ) {
              total += element.data.SupplierBatchReturnedQty;
            }

            total += value;
          });

          let parentItems = gridInstance.getDataSource().items();
          let index = parentItems.findIndex((x) => x.LineNo === LineNo);

          if (total > 0) {
            if (index !== -1) {
              let lineItem = parentItems[index];
              lineItem.CheckInclude = true;
              lineItem.SupplierReturnedQty = total;
              lineItem.ExFXTotal = (
                total * lineItem.SupplierFXPrice
              ).roundNumber(2);
              if (lineItem.TaxRate === 0) {
                lineItem.TaxFXTotal = 0;
                lineItem.IncTaxFXTotal = (
                  total * lineItem.SupplierFXPrice
                ).roundNumber(2);
              } else {
                lineItem.TaxFXTotal = (
                  total *
                  lineItem.SupplierFXPrice *
                  (1 / lineItem.TaxRate)
                ).roundNumber(2);
                lineItem.IncTaxFXTotal = (
                  total * lineItem.SupplierFXPrice +
                  total * lineItem.SupplierFXPrice * (1 / lineItem.TaxRate)
                ).roundNumber(2);
              }
            }
          } else {
            if (index !== -1) {
              let lineItem = parentItems[index];
              lineItem.CheckInclude = false;
              lineItem.SupplierReturnedQty = 0;
              lineItem.ExFXTotal = 0;
              lineItem.TaxFXTotal = 0;
              lineItem.IncTaxFXTotal = 0;
            }
          }

          var refInstance =
            this.$refs["goods-return"].$refs.transactionGrid.$refs[
              `cx-child-grid-${LineNo}`
            ].$refs["select-all-CheckInclude"].instance;

          var checkBox = refInstance.element();
          var checkBoxInstance = CheckBox.getInstance(checkBox);

          checkBoxInstance.option("value", total > 0);
        });
      });
      // }
    },
    onSupplierBatchReturnedQtyChange(value, lineData, items, grid, lineParent) {
      lineData.data.SupplierBatchReturnedQty = value;
      let totalBatchPickedQty = 0;
      lineParent.data.ChildDataSource.forEach((x) => {
        totalBatchPickedQty += x.SupplierBatchReturnedQty
          ? x.SupplierBatchReturnedQty
          : 0;
      });
      lineParent.data.SupplierReturnedQty = totalBatchPickedQty;
      if (
        lineData.data.SupplierBatchReturnedQty >
        lineParent.data.SupplierReceivedQty
      ) {
        let errorMsg = {
          Code: lineParent.data.ItemCode,
          Description: lineParent.data.ItemDescription,
          Batch: lineData.data.BatchNo,
          ReturnQty: value,
          AvailableQty: lineData.data.AvailableQty,
        };
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === lineParent.data.ItemCode &&
            x.Batch === lineData.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations[index] = errorMsg;
        } else {
          this.brokenGridValidations.push(errorMsg);
        }
      } else {
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === lineParent.data.ItemCode &&
            x.Batch === lineData.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations.splice(index, 1);
        }
      }

      lineParent.data.CheckInclude = totalBatchPickedQty > 0;
      lineData.data.CheckInclude = totalBatchPickedQty > 0;

      this.$nextTick(() => {
        this.updateLineTotals(value, lineData, grid);
      });
    },
    onSupplierReturnedQtyChange(e, lineData, gridItems, batchItems) {
      // if (e.value > lineData.data.SupplierReceivedQty) {
      //   this.$nextTick(function () {
      //     alert(
      //       `Item : ${
      //         lineData.data.ItemDescription
      //       } has a received quantity of ${formatNumber(
      //         e.value
      //       )} which is more than the outstanding quantity of ${formatNumber(
      //         lineData.data.SupplierReceivedQty
      //       )}.`,
      //       "Validation Errors"
      //     );
      //     e.value = lineData.data.SupplierReceivedQty;
      //   });
      // }
      if (e.component) {
        e.component.beginUpdate();
        e.component.option("value", e.value);
        e.component.endUpdate();
      }
      lineData.data.SupplierReturnedQty = e.value;

      if (e.value !== 0) {
        lineData.data.CheckInclude = true;
      }

      lineData.data.ExFXTotal = (
        e.value * lineData.data.SupplierFXPrice
      ).roundNumber(2);
      if (lineData.data.TaxRate === 0) {
        lineData.data.TaxFXTotal = 0;
        lineData.data.IncTaxFXTotal = (
          e.value * lineData.data.SupplierFXPrice
        ).roundNumber(2);
      } else {
        lineData.data.TaxFXTotal = (
          e.value *
          lineData.data.SupplierFXPrice *
          (1 / lineData.data.TaxRate)
        ).roundNumber(2);
        lineData.data.IncTaxFXTotal = (
          e.value * lineData.data.SupplierFXPrice +
          e.value * lineData.data.SupplierFXPrice * (1 / lineData.data.TaxRate)
        ).roundNumber(2);
      }

      if (batchItems) {
        this.$nextTick(() => {
          lineData.component.refresh().then(() => {
            this.updateHeaderCheckBox(gridItems);
          });
        });
      } else {
        this.updateHeaderCheckBox(gridItems);
      }
    },
    updateHeaderCheckBox(gridItems) {
      let refHeadInstance =
        this.$refs["goods-return"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ].getSeletcAllRef().instance;
      let checkBoxHeader = refHeadInstance.element();
      let getInstanceHeader = CheckBox.getInstance(checkBoxHeader);

      let count = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      if (count > 0 && count !== gridItems.length) {
        getInstanceHeader.option("value", undefined);
      } else if (count === 0) getInstanceHeader.option("value", false);
      else if (count === gridItems.length)
        getInstanceHeader.option("value", true);
    },
    initialized() {
      this.loaded = true;
    },
    async setActiveAccountingPeriod() {
      let startDateResult =
        await GoodsReturnService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.ui.DateInMin = new Date(accountingPeriod.StartDate);
      }
      let endDateResult =
        await GoodsReturnService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        this.ui.DateInMax = new Date(accountingPeriod.EndDate);
      }
    },
    PostProcess(data) {
      let items = [];

      data.forEach((element) => {
        // if (element.Invoiced == "N") {
        if (element["PurchaseDescription"])
          element["ItemDescription"] = element["PurchaseDescription"];
        element["LineComplete"] = element["LineComplete"] === "Y";
        element["SupplierReturnedQty"] = 0;
        element["CheckInclude"] = false;
        element["IncTaxFXTotal"] = 0;
        element["TaxFXTotal"] = 0;
        element["ExFXTotal"] = 0;

        element["OriginalSupplierOutstandingReturnQty"] =
          element.SupplierOutstandingReturnQty;

        element["SupplierAllReturnedQty"] = element.ReturnedQuantity;

        element["SupplierAvailableQty"] =
          element.SupplierReceivedQty - element.SupplierAllReturnedQty;

        element.IncludeDisabled =
          element.Invoiced === "Y" ||
          element.SupplierAvailableQty === 0 ||
          element.SupplierReceivedQty < 0;

        if (element.AvailableQty <= 0 && element.LineType === "G") {
          element.IncludeDisabled = false;
        }

        if (element["IsBatchProduct"] !== "No") {
          this.IsBatchAvailable = true;
          GoodsReturnService.getGoodsInBatches(
            element["GoodsInCode"],
            element["LineNo"]
          ).then((response) => {
            element.SupplierOutstandingReturnQty = response.data.value.reduce(
              (acc, batch) => acc + batch.AvailableQty,
              0
            );

            element["ChildDataSource"] = response.data.value;
            element["ChildDataSource"].forEach((childElement) => {
              childElement["CheckInclude"] = false;
              childElement.IncludeDisabled = element.IncludeDisabled;
              childElement.ParentLineNo = element.LineNo;
              childElement["IncludeDisabled"] =
                childElement["SupplierAvailableQty"] === 0 ||
                childElement["SupplierReceivedQty"] < 0 ||
                childElement["AvailableQty"] <= 0 ||
                element.Invoiced === "Y";
              childElement["SupplierReturnedQty"] = 0;
              childElement["SupplierBatchReturnedQty"] = 0;
              childElement["OriginalSupplierOutstandingReturnQty"] =
                childElement.OutstandingSupplierReturnQty;
            });
          });
        }

        items.push(element);
        // }
      });

      return items;
    },
    async saveGoodsReturn(dataModel, gridItems) {
      if (this.brokenGridValidations.length !== 0) {
        this.validationSummary = [];
        let validationMessages = this.brokenGridValidations.map((item) => {
          return `Batch ${item.Batch} of item : ${
            item.Description
          } has a return quantity of ${formatNumber(
            item.ReturnQty,
            "##,###,###,###,##0.00"
          )} which is more than the available quantity of ${formatNumber(
            item.AvailableQty,
            "##,###,###,###,##0.00"
          )}.`;
        });

        validationMessages.forEach((element) => {
          this.validationSummary.push({
            message: element,
          });
        });
      } else {
        let payload = {
          DateIn: dataModel.DateIn,
          Comment: dataModel.Comment,
          SupplierCode: dataModel.SupplierCode,
          Resupply: dataModel.ResupplyPO ? "Y" : "N",
          GoodsReturnDetails: [],
          DateChanged: dataModel.DateChanged
            ? new Date(dataModel.DateChanged).toISOString().replace("Z", "")
            : null,
        };

        gridItems.forEach((el) => {
          if (el.SupplierReturnedQty !== 0 && el.CheckInclude) {
            let obj = {
              Comment: el.Comment,
              IsVariable: el.IsVariable,
              ItemCode: el.ItemCode,
              SourceGoodsInCode: el.GoodsInCode,
              SourceGoodsInLineNo: el.LineNo,
              ActualStockConversion: el.ActualStockConversion,
              StandardStockConversion: el.StandardStockConversion,
              ReturnedQty: el.SupplierReturnedQty * el.ActualStockConversion,
              SupplierReturnedQty: el.SupplierReturnedQty,
              OriginalSupplierOutstandingReturnQty:
                el.OriginalSupplierOutstandingReturnQty,
              GoodsReturnProductBatches: [],
            };

            if (el.ChildDataSource) {
              el.ChildDataSource.forEach((i) => {
                let objBatch = {
                  ActualStockConversion: i.SupplierConversion,
                  BatchNo: i.BatchNo,
                  Comment: el.Comment,
                  ReturnedQty:
                    i.SupplierBatchReturnedQty * i.SupplierConversion,
                  SupplierReturnedQty: i.SupplierBatchReturnedQty,
                  UseByDate: i.UseByDate,
                  ManufacturedDate: i.ManufacturedDate,
                  BestBeforeDate: i.BestBeforeDate,
                  OriginalSupplierOutstandingReturnQty:
                    i.OriginalSupplierOutstandingReturnQty,
                };
                obj.GoodsReturnProductBatches.push(objBatch);
              });
            } else {
              delete obj.GoodsReturnProductBatches;
            }
            payload.GoodsReturnDetails.push(obj);
          }
        });

        let nonZeroQtys = payload.GoodsReturnDetails.findIndex(
          (item) => item.ReturnedQty !== 0
        );

        if (nonZeroQtys === -1) {
          this.validationSummary = [];
          this.validationSummary.push({
            message: "You must have at least one line returned.",
          });
          return;
        }

        this.setLoading = true;
        await GoodsReturnService.saveGoodsInReturnOrder(payload)
          .then((res) => {
            this.setLoading = true;
            this.$notify(
              `Successfully created Goods In ${res.data.Code}`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/goods-in-review`,
            });

            this.$logger.debug("response", res);
          })
          .catch((error) => {
            this.setLoading = false;

            this.serverError = {
              err: error,
              msg: "Goods Return Failed",
              time: new Date().getTime(),
            };
          });
      }
    },
  },

  watch: {
    IsBatchAvailable: {
      handler(val) {
        if (val && this.CollapseBtnContentReady) {
          this.CollapseBtnContentReady.component.beginUpdate();
          this.CollapseBtnContentReady.component.option("visible", true);
          this.CollapseBtnContentReady.component.endUpdate();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.goods-return {
  .date-in-container {
    padding-right: 0px !important;
  }

  .date-in-container {
    padding-left: 0px !important;
  }

  .colps-expnd-btn {
    margin-left: 35px;
  }
}
</style>
